import { Tab } from '@yleisradio/areena-types';
import { ChannelHeader } from 'components/Guide/ChannelHeader/ChannelHeader';
import { ChannelSelectionMenu } from 'components/Guide/ChannelSelectionMenu/ChannelSelectionMenu';
import { isListArray } from 'utils/content';
import { Channel } from './Channel';
import { useCookie } from 'hooks/useCookie';
import { SummaryViewEventParams } from 'services/snowplowAnalytics/contextGenerators';

interface SelectableChannelProps {
  channel: Tab;
  isFutureDate: boolean;
  isToday: boolean;
  showExpired: boolean;
  sendSummaryViewEvent: (params: SummaryViewEventParams) => void;
}

export const SelectableChannel = (props: SelectableChannelProps) => {
  const { persistentState, image, title = '' } = props.channel;

  const channelContent = isListArray(props.channel.content)
    ? props.channel.content
    : [];

  const [storedRegionalChannel, setStoredRegionalChannel] = useCookie(
    persistentState?.key && `region-${persistentState.key}`
  );

  const currentChannelContent =
    channelContent.find(
      (c) => c.persistentState?.id === storedRegionalChannel
    ) || channelContent[0];

  const handleChannelSelect = (channelId: string) => {
    setStoredRegionalChannel(channelId);
  };

  const channelControl = currentChannelContent?.controls?.find(
    (c) => c.destination?.type === 'service'
  );

  return currentChannelContent ? (
    <Channel
      isToday={props.isToday}
      image={props.channel.image}
      showExpired={props.showExpired}
      channelContent={currentChannelContent}
      title={currentChannelContent.title}
      isFutureDate={props.isFutureDate}
      sendSummaryViewEvent={props.sendSummaryViewEvent}
      channelHeader={(headingId) => (
        <ChannelHeader
          image={channelControl?.image || image}
          title={title}
          headingId={headingId}
        >
          <ChannelSelectionMenu
            onSelect={handleChannelSelect}
            selectedChannel={storedRegionalChannel || undefined}
            channels={channelContent}
          />
        </ChannelHeader>
      )}
    />
  ) : null;
};
